import React from 'react';

const showMoreAndLess = ({ showMore, setShowMore, items }) => {
	if (items?.length > 0) {
		return (
			<>
				{!showMore && (
					<button className="show-more" onClick={() => setShowMore(true)}>
						Show more
					</button>
				)}
				{showMore && (
					<button className="show-more" onClick={() => setShowMore(false)}>
						Show less
					</button>
				)}
			</>
		);
	} else {
		return <></>;
	}
};

export default showMoreAndLess;
